import { render, staticRenderFns } from "./log2.vue?vue&type=template&id=d2dc3756&scoped=true"
import script from "./log2.vue?vue&type=script&lang=js"
export * from "./log2.vue?vue&type=script&lang=js"
import style0 from "./log2.vue?vue&type=style&index=0&id=d2dc3756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dc3756",
  null
  
)

export default component.exports